export default "__VITE_ASSET__3834eef3__"